/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  PurgeUserAndMailTemplateOrganizationResponseData,
  PurgeUserAndMailTemplateOrganizationResponseDataFromJSON,
  PurgeUserAndMailTemplateOrganizationResponseDataFromJSONTyped,
  PurgeUserAndMailTemplateOrganizationResponseDataToJSON
} from './PurgeUserAndMailTemplateOrganizationResponseData'

/**
 *
 * @export
 * @interface GetJobResponse
 */
export interface GetJobResponse {
  /**
   *
   * @type {number}
   * @memberof GetJobResponse
   */
  status?: number
  /**
   *
   * @type {PurgeUserAndMailTemplateOrganizationResponseData}
   * @memberof GetJobResponse
   */
  data?: PurgeUserAndMailTemplateOrganizationResponseData
}

export function GetJobResponseFromJSON(json: any): GetJobResponse {
  return GetJobResponseFromJSONTyped(json, false)
}

export function GetJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJobResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : PurgeUserAndMailTemplateOrganizationResponseDataFromJSON(json['data'])
  }
}

export function GetJobResponseToJSON(value?: GetJobResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: PurgeUserAndMailTemplateOrganizationResponseDataToJSON(value.data)
  }
}
